// automations stream: the scheduled rules card in Settings.
export const en: Record<string, string> = {
  "automations.title": "Automations",
  "automations.sub": "The clock: rules the server runs every hour. Tasks always; texts only when you say so.",
  "automations.renewalReminders": "Renewal reminders",
  "automations.renewalReminders.sub": "A task for the owner 30, 15 and 5 days before a policy expires.",
  "automations.renewalReminders.autoText": "Also text the customer (needs SMS consent; respects quiet hours)",
  "automations.noticeEscalation": "Notice escalation",
  "automations.noticeEscalation.sub": "An untouched carrier notice past its one-business-day SLA becomes an owner task after",
  "automations.hours": "hours",
  "automations.birthdays": "Birthdays",
  "automations.birthdays.sub": "A task for the owner on the customer's birthday.",
  "automations.retention": "Retention rule",
  "automations.retention.sub": "A renewal within 45 days with a premium increase at or above the threshold is flagged for remarket with a task.",
  "automations.retention.pct": "Increase threshold (%)",
  "automations.crossSell": "Cross-sell detector",
  "automations.crossSell.sub": "Every Monday: active auto customers with no home or renters policy get a card on Cross-sell.",
  "automations.ownerDigest": "Owner digest",
  "automations.ownerDigest.sub": "Every Monday at 7 AM: last week's numbers, what is due, who is behind. Stored in Documents and emailed when email is live.",
  "automations.ownerDigest.email": "Email it to owners",
  "automations.runNow": "Run now",
  "automations.ran": "Rules ran",
  "automations.lastRun": "Last run",
  "automations.never": "Not run yet",
  "automations.digest": "Latest digest",
  "automations.noDigest": "No digest yet. It arrives Monday, or press Run now to write one from today's numbers.",
  "automations.saved": "Automation settings saved",
  "automations.enabled": "On",
};

export const es: Record<string, string> = {
  "automations.title": "Automatizaciones",
  "automations.sub": "El reloj: reglas que el servidor ejecuta cada hora. Siempre crean tareas; mensajes solo si tú lo autorizas.",
  "automations.renewalReminders": "Recordatorios de renovación",
  "automations.renewalReminders.sub": "Una tarea para el responsable 30, 15 y 5 días antes de que venza la póliza.",
  "automations.renewalReminders.autoText": "También enviar mensaje al cliente (requiere consentimiento SMS; respeta el horario)",
  "automations.noticeEscalation": "Escalación de avisos",
  "automations.noticeEscalation.sub": "Un aviso sin atender después de su plazo de un día hábil se vuelve tarea del dueño después de",
  "automations.hours": "horas",
  "automations.birthdays": "Cumpleaños",
  "automations.birthdays.sub": "Una tarea para el responsable el día del cumpleaños del cliente.",
  "automations.retention": "Regla de retención",
  "automations.retention.sub": "Una renovación a 45 días o menos con un aumento de prima igual o mayor al umbral se marca para recotizar, con tarea.",
  "automations.retention.pct": "Umbral de aumento (%)",
  "automations.crossSell": "Detector de venta cruzada",
  "automations.crossSell.sub": "Cada lunes: clientes activos con auto y sin casa ni inquilinos reciben una tarjeta en Venta cruzada.",
  "automations.ownerDigest": "Resumen para el dueño",
  "automations.ownerDigest.sub": "Cada lunes a las 7 AM: números de la semana, qué vence, quién va atrasado. Se guarda en Documentos y se envía por correo cuando el correo está activo.",
  "automations.ownerDigest.email": "Enviar por correo a los dueños",
  "automations.runNow": "Ejecutar ahora",
  "automations.ran": "Reglas ejecutadas",
  "automations.lastRun": "Última ejecución",
  "automations.never": "Aún no se ejecuta",
  "automations.digest": "Último resumen",
  "automations.noDigest": "Todavía no hay resumen. Llega el lunes, o presiona Ejecutar ahora para generarlo con los números de hoy.",
  "automations.saved": "Automatizaciones guardadas",
  "automations.enabled": "Activo",
};
